/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SaveBookingSitePayload = {
    title?: string | null;
    categoryIds: Array<number>;
    layout?: SaveBookingSitePayload.layout;
    active?: boolean;
    showAddress?: boolean;
    requireEmailConfirmation?: boolean;
};
export namespace SaveBookingSitePayload {
    export enum layout {
        COMPACT = 'compact',
        EXTENDED = 'extended',
    }
}

